import { HighPrioritySchoolIndicator } from '@/components/high-priority-school-indicator.js';

interface AttendanceSchoolCellProps {
  name: string;
  isHighPriority?: boolean | null;
  studentGroupId: string;
}

export function AttendanceSchoolCell({ name, isHighPriority, studentGroupId }: AttendanceSchoolCellProps) {
  return (
    <span className="inline-flex items-center gap-1">
      {name}
      <HighPrioritySchoolIndicator
        isHighPriority={isHighPriority}
        data-testid={`teachers-attendance-table-icon-high-priority-school-${studentGroupId}`}
      />
    </span>
  );
}
